<template>
    <div id="docUpload">
        <section id="docUploadSection" class="clearfix p-3">
            <h2><a id="docAnchor" name="docAnchor"></a>Document Upload To Registrar</h2>
            <form>
                <p>For your security, files uploaded from this location are transferred to a secure 
                location in the Office of the Registrar and accessible only to persons responsible for 
                processing changes to or verifying your personal information. Send an email to <a href="mailto:registration@illinois.edu">registration@illinois.edu</a> after upload 
                to explain the purpose of the uploaded document.<strong>Do NOT upload the following types of documents here:</strong>
                <ul>
                    <li><a href="https://osfa.illinois.edu/documentupload/" target="_blank">Office of Financial Aid documents </a></li>
                    <li><a href="https://mckinley.illinois.edu/new-students/immunization-information" target="_blank">Immunization Records</a></li>
                    <li><a href="https://registrar.illinois.edu/academic-records/trans-credit/" target="_blank">Transcripts for transfer credit</a></li>
                    <li>Test Scores <br/>
                        <span class="pl-3 d-block">Official test scores need to be sent directly from the testing agency.</span>
                    </li>
                    <li>Other school course syllabi for transfer credit<br/>
                        <span class="pl-3 d-block">If you are a new student please upload these by logging into myIllini as a 'Future Student' and accessing the
                            Online Syllabus Form.  If you no longer have access to myIllini as a future student, you may email the syllabi 
                            as PDF documents to <a href="mailto:ouacoursearticulation@illinois.edu">ouacoursearticulation@illinois.edu</a></span>
                    </li>
                </ul>
                
                </p>
                <div class="form-group">
                    <label for="file">Upload PDF or jpg documentation (8MB Limit).</label><br/>
                    <input type="file" id="file" ref="file" v-on:change="handleFileChange()"/>
                </div>
                <p>By pressing the Upload File button, I acknowledge the information in the attached 
                document is an accurate representation of a legal document needed for proof of personal 
                information to the Office of the Registrar.</p>
                <div class="form-group">
                    <button class="btn btn-primary mt-3" v-on:click="startDocumnentUpload()" type="button">Upload File</button><br/>
                    <a href="https://myillini.illinois.edu/pdf/Creating_a_pdf.pdf" target="_blank">Help creating a pdf</a>
                </div>   
                <div class="form-group" v-if="documentUploaded == 1">
                    <spinner></spinner>
                </div>
                
            </form>
            <div v-if="documentUploaded == 3" class="bg-danger mb-3 p-1">
                <p class="text-white">There was a problem uploading the document. Please check that your file was a pdf or jpg file and the size was not over 10mb.</p>
            </div>
            <div v-if="documentUploaded == 2" class="bg-success mb-3 p-1">
                <p class="text-white">File uploaded successfully</p>
            </div>  
        </section>
        
    </div>
</template>

<script>
    import spinner from "../components/spinner.vue";
    import { isNullOrUndefined } from 'util';
    export default {
        name: 'DocUpload',
        components: { spinner },
        data() {
            return {
                docType: "SSN",
                file: ''
            }
        },
        computed: {
            documentUploaded() { return this.$store.state.docIsUploaded },
        },
        methods: {
            startDocumnentUpload() {
                
                var flCont = this.$refs.file;
                //validate
                if (isNullOrUndefined(flCont) || isNullOrUndefined(flCont.files[0])) {
                    alert("You must selected a file.");
                } else {
                    var fl = flCont.files[0];
                    var ext = fl.name.substring(fl.name.lastIndexOf(".") + 1).toLowerCase();
                    if (fl.length <= 0 || fl.size > (10 * 1000 * 1000)) {
                        alert("Please use a file size less than 8MB.");
                    } else if (ext != "pdf" && ext != "jpg" && ext != "jpeg") {
                        alert("You must use either a pdf of jpg file.");
                    } else {
                        this.$store.commit("setDocIsUploaded", 1)
                        this.$store.dispatch("uploadDocument");
                        this.$refs.file.value = '';
                    }
                }
                
                return false;
            },
            handleFileChange() {
                this.$store.commit("setDocumentToUpload", this.$refs.file.files[0]);
            }

        }
    };
</script>